// auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SecurityContextService } from '@services/security_context.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private _router: Router,
    private securityContextService: SecurityContextService,
  ) {}
  canActivate(): boolean {
    if (this.securityContextService.isLoggedIn()) {
      return true;
    } else {
      this.securityContextService.logOut();
      this._router.navigate(['/login']);
      return false;
    }
  }
}
